"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIDCardtURL = exports.getIDCardHeaders = exports.getDigitalIdPDF = exports.getDigitalId = exports.getChoiceIDCardURL = void 0;
var _environment = _interopRequireDefault(require("../../environment"));
var _urlUtils = require("../../util/urlUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*global fetch:false*/
var baseUrl = _environment.default.POLICY.policyUrl;
var CONFIG = _environment.default.CONFIG;
var getDigitalId = exports.getDigitalId = function getDigitalId(policyNmber, id, auth) {
  var config = Object.assign({}, CONFIG);
  config = _environment.default.ADD_AUTH_HEADER(config, auth);
  return fetch(baseUrl + '/' + policyNmber + '/digital-card/' + id, config).then(function (res) {
    if (res.ok || res.status === 400) {
      return res.json();
    } else {
      return {
        error: {
          code: res.status,
          message: res.statusText
        }
      };
    }
  }).catch(function (err) {
    return {
      error: {
        code: 1,
        message: err.message
      }
    };
  });
};
var getDigitalIdPDF = exports.getDigitalIdPDF = function getDigitalIdPDF(policyNumber, vin, auth) {
  var config = Object.assign({}, CONFIG);
  config = _environment.default.ADD_AUTH_HEADER(config, auth);
  return fetch(baseUrl + '/' + policyNumber + '/pdf-card/' + vin, config).then(function (res) {
    if (res.ok || res.status === 400) {
      return res.json();
    } else {
      return {
        error: {
          code: res.status,
          message: res.statusText
        }
      };
    }
  }).catch(function (err) {
    return {
      error: {
        code: 1,
        message: err.message
      }
    };
  });
};
var getIDCardtURL = exports.getIDCardtURL = function getIDCardtURL(policyNumber, vin) {
  return (0, _urlUtils._url)(baseUrl, policyNumber, 'pdf-card/' + vin);
};
var getChoiceIDCardURL = exports.getChoiceIDCardURL = function getChoiceIDCardURL(policyNumber) {
  return (0, _urlUtils._url)(baseUrl, policyNumber, 'choice-pdf-card');
};
var getIDCardHeaders = exports.getIDCardHeaders = function getIDCardHeaders(auth) {
  return _environment.default.ADD_AUTH_HEADER(_objectSpread({}, CONFIG, {
    headers: _objectSpread({}, CONFIG.headers, {
      Accept: 'application/pdf'
    })
  }), auth);
};